import { render, staticRenderFns } from "./TestsBlock.vue?vue&type=template&id=03cef070"
import script from "./TestsBlock.vue?vue&type=script&lang=js"
export * from "./TestsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports